import React from "react";

const ButtonForm= ({children, onClick, className}) => {
    return(
        <button 
            onClick={onClick}
            className={`px-4 py-2 font-semibold rounded-lg ${className}`}
        >
            {children}
        </button>
    )
}

export default ButtonForm;